export default "__VITE_ASSET__uWespBjI__"